import { Check, X, TrendingUp, TrendingDown, Minus } from 'lucide-react';

const PERIODS = [
  { key: 'today', label: 'T', verbose: 'Today' },
  { key: 'week',  label: 'W', verbose: 'This week' },
  { key: 'month', label: 'M', verbose: 'This month' },
  { key: 'year',  label: 'Y', verbose: 'This year' },
];

const STATUS_LABEL = { hit: 'Hit', beat: 'Beat', miss: 'Miss', pend: 'Pending' };

const STATUS_ICON = {
  hit:  <Check size={7} strokeWidth={4} />,
  beat: <TrendingUp size={7} strokeWidth={3.5} />,
  miss: <X size={7} strokeWidth={4} />,
  pend: null,
};

const DIRECTION_ICON = {
  bull: <TrendingUp size={10} strokeWidth={2.5} />,
  bear: <TrendingDown size={10} strokeWidth={2.5} />,
  flat: <Minus size={10} strokeWidth={2.5} />,
};

function formatPrice(n) {
  if (n == null) return '—';
  return '$' + Math.round(n).toLocaleString('en-US');
}

function StatusPill({ label, status, verbose }) {
  return (
    <span
      className={`wl-pill wl-pill-${status}`}
      title={`${verbose}: ${STATUS_LABEL[status]}`}
    >
      {label}{STATUS_ICON[status]}
    </span>
  );
}

function TodayCall({ call }) {
  if (!call) return null;
  const { direction, low, high } = call;
  return (
    <div className="wl-today">
      <span className="wl-today-lbl">Today</span>
      <span
        className={`wl-today-call ${direction}`}
        title={`Projected close: ${formatPrice(low)} – ${formatPrice(high)} (${direction})`}
      >
        {DIRECTION_ICON[direction]}
        {formatPrice(low)}–{formatPrice(high)}
      </span>
    </div>
  );
}

export function WatchlistCard({
  ticker,
  name,
  price,
  change,
  todayCall,
  projections,
  active = false,
  onClick,
}) {
  const priceFmt = price != null
    ? price.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    : '—';
  const dir    = change == null ? 'flat' : change > 0 ? 'up' : change < 0 ? 'dn' : 'flat';
  const sign   = change != null && change > 0 ? '+' : '';
  const chgStr = change != null ? `${sign}${change.toFixed(2)}%` : null;

  function handleKey(e) {
    if (e.key === 'Enter' || e.key === ' ') {
      e.preventDefault();
      onClick?.();
    }
  }

  return (
    <div
      className={`wl-card${active ? ' active' : ''}`}
      role="button"
      tabIndex={0}
      onClick={onClick}
      onKeyDown={handleKey}
    >
      <div className="wl-row1">
        <span className="wl-code">{ticker}</span>
        <span className="wl-price">${priceFmt}</span>
      </div>
      <div className="wl-row2">
        <span className="wl-name" title={name}>{name}</span>
        {chgStr && <span className={`wl-chg ${dir}`}>{chgStr}</span>}
      </div>
      <TodayCall call={todayCall} />
      <div className="wl-projections">
        {PERIODS.map(p => (
          <StatusPill
            key={p.key}
            label={p.label}
            verbose={p.verbose}
            status={projections?.[p.key] ?? 'pend'}
          />
        ))}
      </div>
    </div>
  );
}
